import { CompassCardUI } from '@scale/compass-ui/types';
import {
  SphereEngineExecutionCardShared,
  type SphereEngineExecutionSchemaType,
  type SphereEngineExecutionContext,
  SPHERE_ENGINE_EXECUTION,
} from '@scale/genai-compass-shared/cards/sphere_engine_execution';
import SphereEngineExecutionCardComponent from './SphereEngineExecutionCardComponent';
import { faPlayCircle } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: SphereEngineExecutionContext = {
  cardType: SPHERE_ENGINE_EXECUTION,
  fileColumnIds: [],
  fileColumnRegex: '',
  sphere_scenario: 'run',
  timeoutSeconds: 250,
};

export const SphereEngineExecutionCardInfo: CompassCardUI<SphereEngineExecutionSchemaType> = {
  ...SphereEngineExecutionCardShared,
  title: 'Sphere Engine Execution',
  icon: 'play-circle',
  toolTip: 'Execute tests in isolated Sphere Engine containers',
  defaultContext,
  ownerTeam: 'Chat Task',
  isAdvanced: true,
  button: {
    icon: faPlayCircle,
  },
  legacyComponent: SphereEngineExecutionCardComponent,
};
